import { render, staticRenderFns } from "./RainDetail.vue?vue&type=template&id=2f138c20&scoped=true&"
import script from "./RainDetail.vue?vue&type=script&lang=js&"
export * from "./RainDetail.vue?vue&type=script&lang=js&"
import style0 from "./RainDetail.vue?vue&type=style&index=0&id=2f138c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f138c20",
  null
  
)

export default component.exports